import { AxiosError } from 'axios';


export enum LearningMapTypes {
    GET_CURRENT_LEARNING_MAP_REQUEST = '@LearningMapTypes/GET_CURRENT_LEARNING_MAP_REQUEST',
    GET_CURRENT_LEARNING_MAP_SUCCESS = '@LearningMapTypes/GET_CURRENT_LEARNING_MAP_SUCCESS',
    GET_CURRENT_LEARNING_MAP_FAILURE = '@LearningMapTypes/GET_CURRENT_LEARNING_MAP_FAILURE',

    SAVE_CURRENT_LEARNING_MAP_REQUEST = '@LearningMapTypes/SAVE_CURRENT_LEARNING_MAP_REQUEST',
    SAVE_CURRENT_LEARNING_MAP_SUCCESS = '@LearningMapTypes/SAVE_CURRENT_LEARNING_MAP_SUCCESS',
    SAVE_CURRENT_LEARNING_MAP_FAILURE = '@LearningMapTypes/SAVE_CURRENT_LEARNING_MAP_FAILURE',
    SAVE_CURRENT_LEARNING_MAP_CLEAR = '@LearningMapTypes/SAVE_CURRENT_LEARNING_MAP_CLEAR',

    GET_HISTORY_LEARNING_MAP_REQUEST = '@LearningMapTypes/GET_HISTORY_LEARNING_MAP_REQUEST',
    GET_HISTORY_LEARNING_MAP_SUCCESS = '@LearningMapTypes/GET_HISTORY_LEARNING_MAP_SUCCESS',
    GET_HISTORY_LEARNING_MAP_FAILURE = '@LearningMapTypes/GET_HISTORY_LEARNING_MAP_FAILURE',

    GET_WORDCLOUD_CATEGORIES_DATA_REQUEST = '@LearningMapTypes/GET_WORDCLOUD_CATEGORIES_DATA_REQUEST',
    GET_WORDCLOUD_CATEGORIES_DATA_SUCCESS = '@LearningMapTypes/GET_WORDCLOUD_CATEGORIES_DATA_SUCCESS',
    GET_WORDCLOUD_CATEGORIES_DATA_FAILURE = '@LearningMapTypes/GET_WORDCLOUD_CATEGORIES_DATA_FAILURE',
    GET_WORDCLOUD_CATEGORIES_DATA_CLEAR = '@LearningMapTypes/GET_WORDCLOUD_CATEGORIES_DATA_CLEAR',
}

export interface LearningMap {
    id: number;
    minutes: number;
    consumedMinutes: number;
    favoriteContentType: string[];
    classificationIds: number[];
    emailSuggestions: boolean;
    suggestionTimeOfTheDay: string;
    updatedOn: Date;
    startDate: Date;
    finishDate: Date;
    totalFinishedContents: number;
    mediaTypeWithConsumption: MediaTypeWithConsumption[];
}

export interface LearningMapState {
    data: { currentLearningMap: LearningMap };
    historyLearningMapList: LearningMap[];
    wordcloudCategories: WordCloudCategory[];
    hasError: boolean;
    loading: boolean;
    error?: AxiosError;
    success: boolean;
    successOnSave: boolean;
    errorOnSave: boolean;
}

export interface MediaTypeWithConsumption {
    mediaType: string;
    consumedMinutes: number;
    consumedAmount: number;
}

export interface WordCloudCategoriesDataRequest {
    moduleIds: string;
}

export interface WordCloudCategory {
    categoryId: number;
    categoryName: string;
    totalFinished: number;
    wordCloudPoints: number;
}
